/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description Utils for Response Screen of Eligibility
 */
import _ from 'lodash';
import { covertDateToStringArray, DATE_PRESETS } from 'utils/dateParser';

const dataKeys = {
	eligibilityId: 'eligibilityId',
	patientName: 'patientName',
	patientIdentifier: 'patientIdentifier',
	inquiryDate: 'inquiryDate',
	providerId: 'providerId',
	payerId: 'payerId',
	coverageStatus: 'coverageStatus',
	locationId: 'locationId',
	dateOfService: 'dateOfService',
	coverageId: 'coverageId',
	batchId: 'batchId',
	insuranceType: 'insuranceType',
	hasAdditionalPayers: 'hasAdditionalPayers',
};

const dataKeyLabels = {
	patientName: 'Patient Name',
	patientIdentifier: 'Patient Identifier',
	inquiryDate: 'Inquiry Date',
	providerId: 'Provider/Org',
	payerId: 'Payer',
	coverageStatus: 'Status',
	locationId: 'Service Location',
	dateOfService: 'Service Date',
	batchId: 'Batch ID',
	insuranceType: 'Insurance Type',
	hasAdditionalPayers: 'Additional Insurance',
};

const EXPORT_OPTIONS = [
	{ value: covertDateToStringArray(DATE_PRESETS.monthToDate.value), label: DATE_PRESETS.monthToDate.label },
	{ value: covertDateToStringArray(DATE_PRESETS.lastMonth.value), label: DATE_PRESETS.lastMonth.label },
	{ value: covertDateToStringArray(DATE_PRESETS.lastThreeMonths.value), label: DATE_PRESETS.lastThreeMonths.label },
];

const dateType = {
	radio: 'radio' as EligibilityRequests.IExportDateRangeType,
	datePicker: 'date-picker' as EligibilityRequests.IExportDateRangeType,
};

const getPatientName = (name?: EligibilityRequests.IPatientName): string => {
	const nameArray = _.compact([name?.firstname, name?.middlename, name?.lastname]);
	if (_.isEmpty(nameArray)) {
		return '';
	}
	return _.join(nameArray, ' ');
};

const prepareDateRange = (date: [string, string]): EligibilityRequests.IDateRange => {
	return { startDate: _.first(date) || '', endDate: _.last(date) || '' };
};

const getServiceTypesLabel = (record: EligibilityRequests.IEligibilityData, serviceTypesOptions?: IMultiSelectOption[]): string => {
	if (_.isArray(record?.requestInfo?.serviceType)) {
		const matchingOptions = _.filter(serviceTypesOptions, (option) => _.includes(record?.requestInfo?.serviceType, option.value));
		return _.map(matchingOptions, 'label').join(', ');
	} else {
		return _.find(serviceTypesOptions, { value: record?.requestInfo?.serviceType })?.label || '';
	}
};

const getFilterLabel = (label: string, count: number): string => {
	if (count === 0) {
		return label;
	}
	return `(${count}) ${label}`;
};

const filterEmptyValue: (params: AnyRecord) => AnyRecord = (params) => {
	return _.pickBy(params, (value) => !_.isEmpty(value) || _.isBoolean(value));
};

export {
	dataKeys,
	dataKeyLabels,
	EXPORT_OPTIONS,
	dateType,
	getPatientName,
	prepareDateRange,
	getServiceTypesLabel,
	getFilterLabel,
	filterEmptyValue,
};
